<template>
  <sidebar-right
    @overlayClicked="outside"
    :class="[
      'navbar-collapse offcanvas-collapse offcanvas-collapse--right offcanvas-collapse--400',
      { open: show }
    ]"
  >
  
    <div class="bg-white md__card--holder clearfix">
      <div>
        <!-- Card header -->
        <span class="d-flex chat-header-title yellow-class">
          <!-- Title -->
          <!-- <div class="col px-0"> -->
            <span class="header-title">Approval Request <span class="bracket"> { </span></span> 
          <!-- </div> -->
        </span>

        <div class="card-header">
          <!-- <h5
              v-if="
                currentProject && currentProject.payment_status == 'SUCCESS'
              "
            >
              Approval Status:
              <span style="color:red" class="error"
                >({{ currentProject.approval_status.replace("_", " ") }})</span
              >
            </h5>
            <span
              style="color:red"
              class="error"
              v-if="
                currentProject &&
                  currentProject.approver &&
                  currentProject.payment_status == 'SUCCESS'
              "
              >{{(currentProject.approver.user.id == profile.id)?"You are":currentProject.approver.user.first_name + ' is'}} the current client
              of this project.</span
            > -->
          <p>
            Invite your client to approve this project
          </p>
        </div>
      </div>

      <div
        class="payment-block"
        v-if="currentProject"
      >
        <div class="card card-body">
          <UserPicker
            v-model="userInvite"
            :multi="false"
            
            role="APPROVER"
          />
          <button
            class="btn  btn-success mt-4"
            @click="_requestApproverClicked"
          >
            <span class="icon-sml">
              <i class="fas fa-pay"></i>
              Request Now
            </span>
          </button>
        </div>
      </div>
    </div>
  </sidebar-right>
</template>

<script>
import swal from "sweetalert2";
import { VueAvatar } from "vue-avatar-editor-improved";
import "sweetalert2/dist/sweetalert2.css";
import { mapState, mapActions, mapMutations } from "vuex";
import Modal from "@/components/Modal";
import AssignCompany from "@/app/components/AssignCompany.vue";
import axios from "axios";
import UserPicker from "@/app/components/UserPicker.vue";
import SidebarRight from "../layout/SidebarRight.vue";
import { required, minLength, between, email } from "vuelidate/lib/validators";

export default {
  name: "Approval",
  props: ["show", "fullWidth", "project"],
  components: {
    VueAvatar,
    AssignCompany,
    UserPicker,
    SidebarRight
  },

  data() {
    return {
      pendingProjects: [
        { id: 1, name: "Demo Project" },
        { id: 2, name: "Mobile App Development" },
        { id: 3, name: "Next JS Project" },
        { id: 4, name: "Bracket development and release" },
        { id: 5, name: "My Favourite One" }
      ],
      userInvite: {},
      form: {
        customer: {},
        rebillCC: {}
      },
      showCurrency: true,
      paymentMode: "me",
      paymentInfo: {},
      editMode: true, //later will use profile.hasCard

      selects: {
        showCurrency: "",
        currency: [
          { value: "USD", label: "United states", symbol: "$" },
          { value: "AUD", label: "Australia", symbol: "$" },
          { value: "EUR", label: "Euro", symbol: "€" },
          { value: "GBP", label: "Pound Sterling", symbol: "£" },
          { value: "CAD", label: "Canada", symbol: "$" }
        ]
      },
      showCropper: false
    };
  },

  validations: {
    form: {
      customer: {
        first_name: {
          required
        }
      },
      rebillCC: {
        name: {
          required
        },
        number: {
          required
        },
        cvc: {
          required
        },
        exp_month: {
          required
        },
        exp_year: {
          required
        }
      }
    }
  },

  watch: {
    project () {
      this.fetchPayment()
    }
  },

  computed: {
    ...mapState("user", ["profile", "banners"]),
    ...mapState("common", ["countries"]),
    extraPayableSelectedProjects() {
      return (this.paymentInfo.projects || []).filter(p => p.checked);
    },

    extraPayableProjects() {
      return (this.paymentInfo.projects || []).filter(
        p => p.id != this.project.id
      );
    },

    currentProject() {
      return this.paymentInfo.currentProject;
    },

    getTotalPayableCost() {
      return (this.extraPayableSelectedProjects.length + 1) * 5;
    },

    getCompanyName() {
      if (this.profile.company && this.profile.company.website) {
        const website = this.profile.company.website;
        const matches = website.match(/^https?\:\/\/([^\/?#]+)(?:[\/?#]|$)/i);
        const domain = matches && matches[1]; // domain will be null if no match is found
        return domain;
      }
    }
  },

  mounted() {
    this.$nextTick(async () => {
      await this.fetchPayment();

      this.form = {
        ...this.form,
        customer: { ...this.profile, image: null, user_preference: null }
      };
      this.userInvite = this.currentProject?this.currentProject.approver: null
    });
  },
  methods: {
    ...mapActions("user", [
      "savePreference",
      "updateProfileInfo",
      "deleteBanner",
      "saveBanner",
      "fetchBanners"
    ]),
    ...mapActions("project", [
      "requestApproval",
      "fetchPaymentInfo",
      "createPayement"
    ]),

    async fetchPayment() {
      try {
        let res = await this.fetchPaymentInfo(this.project.id);
        this.paymentInfo = res;
        this.editMode = !this.paymentInfo.billingDetails;
      } catch (e) {
        console.log("eeeeee", e);
        this.$snack.success(
          e.response.data.title || "Error fetching payment info"
        );
      }
    },

    async _onPayNowClicked() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return false;
      }
      try {
        const body = {
          ...this.form,
          assets: [...this.extraPayableSelectedProjects, this.project]
        };
        let res = await this.createPayement(body);
        this.$snack.success(res.message);
        this.fetchPayment();
      } catch (e) {
        this.$snack.success(
          e.response.data.message || "Error creating payment"
        );
      }
    },

    async _requestApproverClicked() {
      if(this.userInvite) {
        let body = {
          ...this.userInvite,
          asset:  this.project
        };
        try {
          let res = await this.requestApproval(body);
          this.$snack.success("Client approval request has been made successfully");
          this.fetchPayment();
          this.$emit('approveSuccess')
        } catch (e) {
          this.$snack.success(e.response.data.message || "Error inviting payer");
        }
      } else {
        this.$snack.success("Please select user to request");
      }
      
    },

    outside() {
      this.$emit("outSideClicked");
    },

    
  }
};
</script>

<style lang="scss">
.el-input input.el-input__inner {
  border-radius: 5px;
}


</style>

<style scoped>

@media only screen and (max-width: 768px){
  .chat-header-title {
    padding-top: 2rem;
  }
}
.chat-header-title{
    background: #212529;
    padding: 0.9rem 1.5rem;
    border-bottom: 5px solid #448aff;
    border-radius: 0;
}
.chat-header-title.green-class{
  border-bottom: 5px solid #2dce89;
}
.chat-header-title.yellow-class {
    border-bottom: 5px solid #fbdf43;
    margin-top: -23px;
}
.chat-header-title h4{
  color: #fff;
}
.header-title{
  font-size: 30px;
  font-weight: bold; 
  color: #ffff;
  margin-bottom: -10px;
  margin-top: 10px;
}
.bracket {
 font-size:30px;
  color: #fddf43;
}

</style>